import './src/scss/fonts.scss';

import RiseupButton from './src/components/RiseupButton/RiseupButton';
import ClosedCard from './src/components/ClosedCard.vue';
import Card from './src/components/Card/Card.vue';
import OverflowMenu from './src/components/OverflowMenu/OverflowMenu.vue';
import OverflowMenuItem from './src/components/OverflowMenu/OverflowMenuItem.vue';
import RiseupBot from './src/components/RiseupBot.vue';
import Popup from './src/components/Popup.vue';
import ColoredPopup from './src/components/ColoredPopup/ColoredPopup.vue';
import ColoredLinePopup from './src/components/ColoredPopup/ColoredLinePopup.vue';
import EditAmountInput from './src/components/EditAmountInput.vue';
import PlainDropdown from './src/components/PlainDropdown.vue';
import TextInput from './src/components/Inputs/TextInput';
import SupportFooter from './src/components/SupportFooter.vue';
import LoginSupportFooter from './src/components/LoginSupportFooter.vue';
import Separator from './src/components/Separator.vue';
import OrSeparator from './src/components/OrSeparator.vue';
import NumberedBullet from './src/components/NumberedBullet.vue';
import SnackBar from './src/components/SnackBar.vue';
import WebShare from './src/components/WebShare.vue';
import TinyLoader from './src/components/TinyLoader/TinyLoader.vue';
import AnimatedNumber from './src/components/AnimatedNumber.vue';
import CollapseTransition from './src/components/CollapseTransition.vue';
import VideoPlayer from './src/components/VideoPlayer.vue';
import AnimatedLoader from './src/components/AnimatedLoader.vue';
import TextArea from './src/components/TextArea.vue';
import Callout from './src/components/Callout.vue';
import Icon from './src/components/Icon.vue';
import IconAndText from './src/components/IconAndText.vue';
import Signature from './src/components/Signature.vue';
import DefaultTextInput from './src/components/DefaultTextInput.vue';
import AmountInput from './src/components/AmountInput.vue';
import AutocompleteInput from './src/components/Inputs/AutocompleteInput';
import InputCopy from './src/components/InputCopy.vue';
import ExpandableSection from './src/components/ExpandableSection.vue';
import Slider from './src/components/Slider.vue';
import SliderPagination from './src/components/SliderPagination.vue';
import installPlugins from './src/plugins';
import Colors from './src/scss/riseup-js-colors.module.scss';
import * as Typography from './src/tokens/typography';
import * as Spacings from './src/tokens/spacings';
import * as BoxShadow from './src/tokens/box-shadows';
import * as BorderRadius from './src/tokens/border-radius';
import RiseupHeader from './src/components/RiseupHeader';
import OverlayColoredPopup from './src/components/ColoredPopup/OverlayColoredPopup';
import CheckBox from './src/components/CheckBox.vue';
import EmailInput from './src/components/Inputs/EmailInput';
import BottomTabsPage from './src/components/Tabs/BottomTabsPage';
import BottomTabsPageBus from './src/components/Tabs/BottomTabsPageBus';
import BottomSheet from './src/components/BottomSheet/BottomSheet';
import BottomSheetMenuItem from './src/components/BottomSheet/BottomSheetMenuItem';
import MenuButton from './src/components/MenuButton';
import ImageHeader from './src/components/ImageHeader';
import InputDropdown from './src/components/InputDropdown';
import Stepper from './src/components/Stepper';
import Tag from './src/components/Tag';
import TabbedSection from './src/components/Tabs/TabbedSection';
import ActionButton from './src/components/ActionButton';
import BaseInput from './src/components/Inputs/BaseInput';
import CashflowCategoryDropdown from './src/components/CashflowCategoryDropdown/CashflowCategoryDropdown.vue';
import CashflowCategoryRadioList from './src/components/CashflowCategoryRadioList.vue';
import DashboardPage from './src/templates/DashboardPage';
import ImageHeaderPage from './src/templates/ImageHeaderPage';
import StickyCtaPage from './src/templates/StickyCtaPage';
import UpsellPage from './src/templates/UpsellPage';
import * as LayoutConsts from './src/utils/layout-consts';
import HeaderPage from './src/templates/HeaderPage';
import PageHeader from './src/templates/PageHeader';
import LogoPage from './src/templates/LogoPage';
import BannerPage from './src/templates/BannerPage';
import ColoredSvg from './src/components/ColoredSVG';
import IconSquare from './src/components/IconSquare/IconSquare';
import SelectionButton from './src/components/SelectionButton';
import SelectionGroup from './src/components/SelectionGroup';
import SquareButton from './src/components/SquareButton';
import SquareButtonsRow from './src/components/SquareButtonsRow';
import { COLOR_VARIANTS as ICON_SQUARE_COLOR_VARIANTS } from './src/components/IconSquare/IconSquare.consts';
import UploadImage from './src/components/UploadImage';
import ActionIcon from './src/components/ActionIcon/ActionIcon.vue';
import Toggle from './src/components/Toggle.vue';
import Spinner from './src/components/Spinner.vue';
import { ACTION_TYPE } from './src/components/ActionIcon/ActionIcon.consts';
import { RISEUP_BUTTON_VARIANT } from './src/components/RiseupButton/RiseupButton.consts';
import { V2CategoryIcon } from "./src/components/CashflowCategoryDropdown/V2CategoryIcon";
import BarGraph from './src/components/BarGraph/BarGraph';
import TextInputV2 from './src/components/InputsV2/TextInput.vue';
import EmailInputV2 from './src/components/InputsV2/EmailInput.vue';
import AmountInputV2 from './src/components/InputsV2/AmountInput.vue';
import InputDropdownV2 from './src/components/InputsV2/InputDropdown.vue';

const V2Components = {
  AutocompleteInput,
  RiseupButton,
  TextInput,
  BaseInput,
  EmailInput,
  CashflowCategoryDropdown,
};

const V2Inputs = {
  TextInputV2,
  EmailInputV2,
  AmountInputV2,
  InputDropdownV2,
};

const Pages = {
  BannerPage,
  DashboardPage,
  HeaderPage,
  ImageHeaderPage,
  LogoPage,
  StickyCtaPage,
  UpsellPage,
};

const components = [
  RiseupButton,
  BottomTabsPage,
  BottomSheet,
  BottomSheetMenuItem,
  MenuButton,
  ClosedCard,
  Card,
  ImageHeader,
  OverflowMenu,
  OverflowMenuItem,
  RiseupBot,
  Popup,
  ColoredPopup,
  ColoredLinePopup,
  CashflowCategoryDropdown,
  EditAmountInput,
  ExpandableSection,
  PlainDropdown,
  TextInput,
  SupportFooter,
  LoginSupportFooter,
  Separator,
  OrSeparator,
  OverlayColoredPopup,
  NumberedBullet,
  SnackBar,
  WebShare,
  TinyLoader,
  AnimatedNumber,
  CollapseTransition,
  VideoPlayer,
  AnimatedLoader,
  Callout,
  CheckBox,
  EmailInput,
  Icon,
  IconAndText,
  Signature,
  Slider,
  SliderPagination,
  DefaultTextInput,
  AmountInput,
  AutocompleteInput,
  InputCopy,
  RiseupHeader,
  InputDropdown,
  Stepper,
  Tag,
  TabbedSection,
  ActionButton,
  ColoredSvg,
  IconSquare,
  SelectionButton,
  SelectionGroup,
  SquareButton,
  SquareButtonsRow,
  PageHeader,
  Toggle,
  Spinner,
  BarGraph,
  CashflowCategoryRadioList,
  ...Object.values(V2Components),
  ...Object.values(Pages),
];

const init = Vue => {
  components.forEach(component => {
    Vue.component(component.name, component);
  });
};

function install(app) {
  installPlugins(app);
}

export default {
  init,
  install,
  RiseupButton,
  BottomTabsPage,
  BottomTabsPageBus,
  BottomSheet,
  BottomSheetMenuItem,
  MenuButton,
  ClosedCard,
  Card,
  ImageHeader,
  OverflowMenu,
  OverflowMenuItem,
  RiseupBot,
  Popup,
  ColoredPopup,
  ColoredLinePopup,
  CashflowCategoryDropdown,
  EditAmountInput,
  PlainDropdown,
  TextInput,
  TextArea,
  SupportFooter,
  LoginSupportFooter,
  Separator,
  OrSeparator,
  OverlayColoredPopup,
  NumberedBullet,
  SnackBar,
  WebShare,
  TinyLoader,
  AnimatedNumber,
  CollapseTransition,
  VideoPlayer,
  AnimatedLoader,
  Callout,
  CheckBox,
  EmailInput,
  Icon,
  IconAndText,
  Signature,
  Slider,
  SliderPagination,
  DefaultTextInput,
  AmountInput,
  AutocompleteInput,
  InputCopy,
  ExpandableSection,
  RiseupHeader,
  InputDropdown,
  Stepper,
  Tag,
  TabbedSection,
  ActionButton,
  ColoredSvg,
  IconSquare,
  UploadImage,
  SelectionButton,
  SelectionGroup,
  SquareButton,
  SquareButtonsRow,
  PageHeader,
  ActionIcon,
  Toggle,
  Spinner,
  BarGraph,
  CashflowCategoryRadioList,
  V2Inputs,
  Pages,
  V2Components,
  HeaderActions: ACTION_TYPE,
  RiseupButtonVariant :RISEUP_BUTTON_VARIANT,
  IconSquareColorVariants: ICON_SQUARE_COLOR_VARIANTS,
  V2CategoryIcon,
  Colors,
  LayoutConsts,
  ...Typography,
  ...Spacings,
  ...BoxShadow,
  ...BorderRadius,
};
